import React, { useCallback, useEffect, useState } from 'react';
import { ChamptionshipHeader } from '~/web-frontend-components/line/matches/list/sport/championship/Header';
import { Match } from './championship/Match';
import { withRouter } from 'react-router';
import { sportsIds } from '~/web-frontend-components/line/matches.mobile/list/sport/championship/Match';
export const Champtionship = withRouter((props) => {
    var _a, _b, _c;
    const [isFavorite, favorite] = useState(props.championshipsHandlers.isFavoriteChampionship(props.championshipID));
    const isFoldedProp = props.championshipsHandlers.isFoldedChampionship(props.championshipID);
    const [isFolded, fold] = useState(isFoldedProp);
    const isIrm = (_a = props.matchCommonProps) === null || _a === void 0 ? void 0 : _a.isIrm;
    useEffect(() => {
        fold(isFoldedProp);
    }, [props.championshipID, isFoldedProp]);
    const onFavorite = useCallback(() => {
        props.championshipsHandlers.favoriteChampionship(props.championshipID, !isFavorite);
        favorite(props.championshipsHandlers.isFavoriteChampionship(props.championshipID));
    }, [props.championshipID, isFavorite]);
    const foldChampionship = useCallback(() => {
        props.championshipsHandlers.foldChampionship(props.championshipID, !isFolded);
        fold(props.championshipsHandlers.isFoldedChampionship(props.championshipID));
    }, [props.championshipID, isFolded]);
    const isSingleMatch = props.match.params.games;
    const sScore = (_c = (_b = props.matches) === null || _b === void 0 ? void 0 : _b[isSingleMatch === null || isSingleMatch === void 0 ? void 0 : isSingleMatch.split('_')[0]]) === null || _c === void 0 ? void 0 : _c.sScore;
    return <table className="l-t" id={`championship_${props.championshipID}`}>
      <tbody>
         {!isSingleMatch || !sScore || !(sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) || isIrm ? <ChamptionshipHeader url={props.url} sportID={props.sportID} title={props.toLocale(props.championship.sportChampionship)} isFavorite={isFavorite} isFolded={isFolded} onFavorite={onFavorite} fold={foldChampionship}/>
            :
                ''}
         {!isFolded && props.championship.sortedMatchIds.map((matchID) => <Match url={props.getMatchURL({
                matchID, teams: {
                    enTeam1: props.matches[matchID].enTeam1,
                    enTeam2: props.matches[matchID].enTeam2
                }
            })} {...props.matchCommonProps} key={matchID} sportID={props.sportID} toLocale={props.toLocale} handlers={props.matchHandlers} matchID={matchID} matchData={props.matches[matchID]}/>)}
      </tbody>
   </table>;
});



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/list/sport/Championship.jsx